import { AuthResponse } from 'types/auth';

export enum AuthActionTypes {
  SET_AUTH = '@@settings/SET_AUTH',
  REMOVE_AUTH = '@@settings/REMOVE_AUTH',
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AuthState extends AuthResponse {}
